import styled from "styled-components";

const table = styled.table<{ width?: string }>`
  width: ${({ width }) => (width ? width : "100%")};
`;

export default {
  table,
};
